import i18n from './i18n';

export const locale = 'en';

export default i18n(locale);